import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M4 4a16 16 0 0 1 16 16","key":"svg-1"}],["path",{"d":"M4 11a9 9 0 0 1 9 9","key":"svg-2"}]]

const IconRss = createReactComponent('outline', 'rss', 'Rss', __iconNode);

export default IconRss;